<div class="w-100" style="padding: 20px; overflow:auto; max-height:95vh;">
	<div class="w-100 jmPageTitle" style="text-align:center">
		Create a Journeys Map Global Account
	</div>

	<ng-container *ngIf="!askExist">
		<div class="w-100" style="text-align:left; margin-top:20px; padding:20px;">
			To take advantage of the new enhancements added to Journeys Map, we are asking you to create a Global Account.
			The Global Account will allow you to maintain your relationship with your current organization as well as connecting to other organizations at the same time.
			All data and capabilities will be preserved within your connected accounts.
			<br /><br />
			Please click "Enroll Now" to start the account creation.
			<span *ngIf="allowCancel">
				Clicking "Remind Me Later" will give you a chance to create it next time.
				<br /><br />
				Note you can postpone the Global Account creation {{postpone}} times and no more.
			</span>
		</div>
		<div *ngIf="screenWidth >= 414" class="w-100" style="text-align:center; margin-top:20px;">
			<button id="btnReminMeLater" (click)="close('cancel')" *ngIf="allowCancel" tabindex="-1" type="button" class="btn btn-outline-primary" style="width:140px;">Remind Me Later</button>
			<button id="btnEnrollNow" (click)="askExist=true" tabindex="0" type="button" class="btn btn-primary" style="width:140px; margin-left:20px;">Enroll Now</button>
		</div>
		<div *ngIf="screenWidth <= 414" class="w-100" style="text-align:center; margin-top:20px;">
			<button id="btnReminMeLater" (click)="close('cancel')" *ngIf="allowCancel" tabindex="-1" type="button" class="btn btn-outline-primary" style="width:100%; margin-bottom: 10px;">Remind Me Later</button>
			<button id="btnEnrollNow" (click)="askExist=true" tabindex="0" type="button" class="btn btn-primary" style="width:100%;">Enroll Now</button>
		</div>
	</ng-container>

	<ng-container *ngIf="askExist">
		<div class="w-100" style="text-align: center; margin-top: 20px; margin-bottom: 40px;">
			Do you already have a global account?
		</div>
		<div class="w-100 row" *ngIf="screenWidth >= 414">
			<div class="col-4 text-center" *ngIf="allowCancel">
				<button id="btnCancel" (click)="close('cancel')" tabindex="-1" type="button" class="btn btn-primary" style="width:100px;">Cancel</button>
			</div>
			<div class="text-center" [ngClass]="allowCancel?'col-4':'col-6'">
				<button id="btnYes" (click)="close('globallogin')" tabindex="-1" type="button" class="btn btn-primary" style="width:100px;">Yes</button>
			</div>
			<div class="text-center" [ngClass]="allowCancel?'col-4':'col-6'">
				<button id="btnNo" (click)="close('globalsignup')" tabindex="0" type="button" class="btn btn-primary" style="width:100px;">No</button>
			</div>
		</div>
		<div class="w-100 row" *ngIf="screenWidth < 414">
			<div class="col-12 text-center" *ngIf="allowCancel">
				<button id="btnCancel" (click)="close('cancel')" tabindex="-1" type="button" class="btn btn-primary" style="width:100%; margin-bottom: 10px;">Cancel</button>
			</div>
			<div class="col-12 text-center">
				<button id="btnYes" (click)="close('globallogin')" tabindex="-1" type="button" class="btn btn-primary" style="width: 100%; margin-bottom: 10px;">Yes</button>
			</div>
			<div class="col-12 text-center">
				<button id="btnNo" (click)="close('globalsignup')" tabindex="0" type="button" class="btn btn-primary" style="width: 100%; margin-bottom: 10px;">No</button>
			</div>
		</div>
	</ng-container>
</div>
